import { useEffect, useState } from "react";
import { PrintJson } from "../../theme/Component/PrintJson";
import { _FixedAsset, _single } from "../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_TEXT } from "../../theme/Component/BasicTable";
import useModal, { MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { RemoteForm } from "./RemoteForm";
import { ListMenu } from "../../theme/Component/ListMenu";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { FileInput } from "../../theme/Component/FileInput";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";

interface Props {
    nameTable: string;
    idApplicationInvoker: any;
    fieldList: any;
    data: any;
    dataParent: any;
    setData: any;
    propertyName: string;
    classForName?: string;
}
export const RemoteTable = ({ nameTable, fieldList, dataParent, idApplicationInvoker, propertyName, data, setData, classForName = "" }: Props) => {

    const [col, setCol] = useState<any>([]);
    const [head, setHead] = useState<any>([]);
    const [form, setForm] = useState<any>({});
    const [rows, setRows] = useState<any>([]);
    const [row, setRow] = useState<any>({});
    const [rowCopy, setRowCopy] = useState<any>({});
    const modalEdit = useModal('Editar', MODAL_md);
    const modalDelete = useModal("Eliminar", MODAL_SM);
    const [editar, setEditar] = useState<boolean>(false);
    const [excel, setExcel] = useState<any>([]);
    const modalImport = useModal("Importar desde Excel", MODAL_md);
    const _fixed = useDataBean(_FixedAsset);
    const [filter,setFilter] = useState<any>({
        controlado:false,
        causa:0
    });


    //lista blanca de componentes que habilitan el importar datos desde excel
    const importData = [
        { name: "fixedassets.actions.FixedAssetThirdChangeAction", label: "Importar desde Excel", action: () => { loadFixedAssetsItemByList() } },
        { name: "fixedassets.actions.FixedAssetDevolutionAction", label: "Importar desde Excel", action: () => { loadFixedAssetsItemByList() } },
        { name: "fixedassets.actions.FixedAssetOutCostMinAssetAction", label: "Importar desde Excel", action: () => { loadFixedAssetsItemByList() } },
    ]

    const enableImport = importData.find(item => item.name === classForName);

    const loadFixedAssetsItemByList = () => {
        console.log(excel);
        _fixed.instance.getFixedAssetsItemByList(_single.getAccountID(), excel.Media, excel.MediaContext).then((res: any) => {
            console.log(res);
            setRows(res);
        })

    }
    const loadFixedAssetsItemByListBaja = () => {
        console.log(excel);
        _fixed.instance.getFixedAssetsItemByList(_single.getAccountID(), excel.Media, excel.MediaContext).then((res: any) => {
            if (Array.isArray(res)) {
                res.forEach(element => {
                    element.DataBeanProperties.ItemDownCause = filter.causa;
                    element.DataBeanProperties.Checked = filter.controlado;
                });
                setRows(res);
            } else {
                toast.error("No se pudo importar la lista, intente nuevamente");
            }
        })

    }
   

    const switchAction = (action: string) => {
        switch (classForName) {
            case "fixedassets.actions.FixedAssetThirdChangeAction":
                loadFixedAssetsItemByList();
                break;
            case "fixedassets.actions.FixedAssetDevolutionAction":
                loadFixedAssetsItemByList();
                break;
            case "fixedassets.actions.FixedAssetOutCostMinAssetAction":
                loadFixedAssetsItemByListBaja();
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if (data) {
            if (data) {
                if (data.length > 0 && rows.length === 0) {
                    let d = [];
                    data.forEach(element => {
                        d.push({ DataBeanProperties: element });
                    });
                    setRows(d);
                }
            }
        }
    }, [data])


    useEffect(() => {

        if (fieldList) {

            const rows = Object.keys(fieldList);
            console.log(rows);

            let filas = [];
            rows.forEach(fila => {
                filas.push(
                    {
                        ...fieldList[fila], "IDProperty": fila, "LineNumber": fieldList[fila].LineNumber ?? 1, "Index": _single.getRandomInt()
                    }
                )
            });
            setCol(filas.sort((a, b) => a.LineNumber - b.LineNumber));
        }
        return () => { setRows([]) }
    }, [])

    useEffect(() => {
        let temp = [];
        rows.forEach(element => {
            temp.push(element.DataBeanProperties)
        });
        setData(temp)
    }, [rows])

    useEffect(() => {
        let h = [];
        let f = [];
        col.forEach(element => {
            if (element.VisibleOnTableRow === true) {
                h.push({
                    title: element.Name,
                    property: element.RenderizedObject ?? element.IDProperty,
                    visible: true,
                    mask: element.Mask ?? MASK_TEXT
                })
            }
        });
        console.log(" ==== CABECERA TABLA ====");
        console.table(h);
        setHead(h);
        if (fieldList) {
            const campForm = Object.keys(fieldList);
            let c = {};
            campForm.forEach(element => {
                if (fieldList[element].VisibleOnTableForm) {
                    c[element] = fieldList[element];
                }
            });
            setForm(c);
        }
    }, [col])

    const addToList = (item: any) => {

        _single.printOut("ITEM => ");
        _single.printOut(item);

        let filtro = [];
        let remove = item.HashCode;
        item.id = _single.getRandomInt();
        filtro.push({
            DataBeanProperties: item
        });

        rows.forEach(element => {
            console.log(element.DataBeanProperties.HashCode, remove, element.DataBeanProperties.HashCode != remove);

            if (element.DataBeanProperties.HashCode != remove) {
                filtro.push(element);
            }
        });

        _single.printOut("FILTRO => ");
        _single.printOut(item);

        setRows(filtro);
        modalEdit.close();
        setEditar(false);
    }
    const agregarItem = (data: any) => {

        data.HashCode = _single.getRandomInt();
        console.log("AGREGAR => ", data);
        // if(data)
        // {
        //     setRow({...data});
        // }else{
        //     setRow({});
        // }
        setRow({});
        modalEdit.open();
    }


    const iconButtonsItem = [
        { nombre: 'Importar Lista', visible: enableImport, icono: 'ri-file-upload-line', evento: () => { modalImport.open() } },
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: () => { agregarItem(dataParent) } },
    ]

    const removeItem = () => {

        let filtro = [];
        rows.forEach(element => {
            if (element.DataBeanProperties.HashCode != row.HashCode) {
                filtro.push(element);
            }
        });
        setRows(filtro);
        modalDelete.close();


    }

    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-edit-2-line', visible: true, evento: () => { modalDelete.open() } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                {head.length > 0 &&
                    <>
                        <fieldset>
                            <legend>{nameTable}</legend>
                            <BasicTable body={rows} head={head} rowSet={setRow} iconButtons={iconButtonsItem} listButtons={listaBotones()}></BasicTable>
                            {/* <PrintJson json={rows}/> */}
                        </fieldset>
                    </>

                }
            </div>
            <div className="col-md-12">
                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal}>
                    <div className="row">
                        <div className="col">
                            <RemoteForm propertyName={propertyName} useAsForm={true} idApplicationInvoker={idApplicationInvoker} fieldList={form} data={row} setData={addToList} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={switchAction} onSubmitLabel="Cargar">
                    <div className="row">
                        {classForName == 'fixedassets.actions.FixedAssetOutCostMinAssetAction' &&
                        <>
                        <div className="col-md-6">
                            <BasicSwitch label="Es Controlado?" estado={filter.controlado}  eventChange={(e:any)=>{setFilter({...filter,"controlado":e})}}/>
                        </div>
                        <div className="col-md-6">
                            <label>Causa Estado</label>
                            <input type="number" className="form-control" value={filter.causa} onChange={(e:any)=>{setFilter({...filter,"causa":parseInt(e.target.value)})}}/>
                        </div>
                        </>
                        }
                        <div className="col-md-6">
                            <FileInput label={importData.find(item => item.name === classForName)?.label} directory="temp" onCreate={(e) => { setExcel(e) }} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={removeItem}>
                    <strong>Eliminar Linea</strong>
                </ModalConfirm>
            </div>

        </div>
    )

} 